import { firebaseAnalyticsAdapter } from '@/adapters/analytics';
import { createUserAwareAnalyticsAdapter } from '@/adapters/analytics/createUserAwareAnalyticsAdapter';
import { getCurrentAccountId } from '@/adapters/analytics/currentAccountId';
import { getCurrentUserId } from '@/adapters/analytics/currentUserId';
import { userPreferencesRepository } from '@/adapters/database/userPreferencesRepository';
import { sentryLogger } from '@/adapters/logger/sentryLogger';
import { createOnboardingStore, type OnboardingAdapters } from '@/stores/createOnboardingStore';

const productionAdapters: OnboardingAdapters = {
  userPreferences: userPreferencesRepository,
  logger: sentryLogger,
  analytics: createUserAwareAnalyticsAdapter(
    firebaseAnalyticsAdapter,
    () => getCurrentUserId(),
    () => getCurrentAccountId(),
  ),
};

const useOnboardingStore = createOnboardingStore(productionAdapters);

export { useOnboardingStore };
